<template>
  <div>
    <Table :columns="columns" :rows="rows" :columnID="'id'">
      <template #headactions>
        <button @click="onAddItem" class="btn btn-xs btn-icon btn-light-success">
          <i class="fa fa-fw fa-plus"></i>
        </button>
      </template>
      <template #rows="{rows}">
        <ComprobanteRow2 v-for="row in rows" :key="row.id" :row="row"></ComprobanteRow2>
        <tr>
          <td :colspan="colSpan" class="text-right"><strong>TOTAL GRAVADA</strong></td>
          <td class="text-right">
            <strong>{{ total.gravada | number(2) }}</strong>
          </td>
        </tr>
        <tr>
          <td :colspan="colSpan" class="text-right"><strong>TOTAL INAFECTA</strong></td>
          <td class="text-right">
            <strong>{{ total.sinIgv | number(2) }}</strong>
          </td>
        </tr>
        <tr>
          <td :colspan="colSpan" class="text-right"><strong>TOTAL IGV</strong></td>
          <td class="text-right">
            <strong>{{ total.igv | number(2) }}</strong>
          </td>
        </tr>
        <tr>
          <td :colspan="colSpan" class="text-right"><strong>TOTAL</strong></td>
          <td class="text-right">
            <strong>{{ total.total | number(2) }}</strong>
          </td>
        </tr>
      </template>
    </Table>
  </div>
</template>

<script>
import InputText from "../../shared/components/InputText.vue";
import ComprobanteRow2 from "./ComprobanteRow2.vue";
import Table from "../../shared/components/Table.vue";
import { mapGetters, mapState } from "vuex";
export default {
  components: { Table, ComprobanteRow2, InputText },
  data() {
    return {};
  },
  computed: {
    columns() {
      const columns = [
        {
          key: "descripcion",
          label: "Descripción",
        },
        {
          key: "tipoIgv",
          label: "Tipo IGV",
          width: 150,
          head_class: "text-center",
        },
        {
          key: "cantidad",
          label: "Cant.",
          width: 90,
          head_class: "text-center",
        },
        {
          key: "precioUnitario",
          label: "P.U.",
          width: 90,
          head_class: "text-center",
        },
        {
          key: "valorUnitario",
          label: "V.U.",
          width: 90,
          head_class: "text-center",
        },
        {
          key: "igv",
          label: "IGV",
          width: 90,
          head_class: "text-center",
        },
        {
          key: "subtotal",
          label: "Subtotal",
          width: 90,
          head_class: "text-center",
        },
        {
          key: "total",
          label: "Total",
          width: 90,
          head_class: "text-center",
        },
      ];

      if (!this.disableItems) {
        columns.unshift({
          key: "actions",
          label: "",
          width: 30,
        });
      }

      return columns;
    },
    colSpan() {
      return this.disableItems ? 7 : 8;
    },
    ...mapState("comprobante2", {
      rows: (state) => state.items,
      comprobante: "comprobante",
    }),
    ...mapGetters("comprobante2", ["total", "disableItems"]),
  },
  methods: {
    onAddItem() {
      this.$store.dispatch("comprobante2/addItem");
    },
  },
};
</script>

<style></style>
